import API_URL from '../config/api';

const trimTrailingSlash = (value = '') => String(value).replace(/\/+$/, '');

const getAssetOrigin = () => {
  if (API_URL.ORIGIN) {
    return trimTrailingSlash(API_URL.ORIGIN);
  }

  return trimTrailingSlash(String(API_URL.BASE || '').replace(/\/api\/?$/, ''));
};

const ASSET_ORIGIN = getAssetOrigin();

const isAbsoluteUrl = (value = '') => /^https?:\/\//i.test(String(value).trim());

export function resolveProductMediaUrl(source = '') {
  const rawValue = String(source || '').trim();

  if (!rawValue) {
    return '';
  }

  if (isAbsoluteUrl(rawValue)) {
    return rawValue;
  }

  const normalizedValue = rawValue.replace(/\\/g, '/');

  if (normalizedValue.startsWith('//')) {
    return `https:${normalizedValue}`;
  }

  if (normalizedValue.startsWith('/storage-proxy.php')) {
    return `${ASSET_ORIGIN}${normalizedValue}`;
  }

  if (normalizedValue.includes('storage-proxy.php?')) {
    return `${ASSET_ORIGIN}/${normalizedValue.replace(/^\/+/, '')}`;
  }

  if (normalizedValue.startsWith('/storage') || normalizedValue.startsWith('/uploads')) {
    return `${ASSET_ORIGIN}${normalizedValue}`;
  }

  if (normalizedValue.includes('/storage/')) {
    return `${ASSET_ORIGIN}${normalizedValue.slice(normalizedValue.indexOf('/storage/'))}`;
  }

  if (normalizedValue.includes('storage/')) {
    return `${ASSET_ORIGIN}/${normalizedValue.slice(normalizedValue.indexOf('storage/'))}`;
  }

  if (normalizedValue.includes('/uploads/')) {
    return `${ASSET_ORIGIN}${normalizedValue.slice(normalizedValue.indexOf('/uploads/'))}`;
  }

  if (normalizedValue.includes('uploads/')) {
    return `${ASSET_ORIGIN}/${normalizedValue.slice(normalizedValue.indexOf('uploads/'))}`;
  }

  if (normalizedValue.includes('static/media/')) {
    return normalizedValue;
  }

  return `${ASSET_ORIGIN}/storage/products/${normalizedValue.replace(/^\/+/, '')}`;
}

export function getProductGalleryImages(product = {}) {
  const safeProduct = product && typeof product === 'object' ? product : {};
  const rawImages =
    Array.isArray(safeProduct.images) && safeProduct.images.length > 0
      ? safeProduct.images
      : Array.isArray(safeProduct.all_category_images)
        ? safeProduct.all_category_images
        : [];

  const seenUrls = new Set();

  return rawImages
    .map((image, index) => {
      const imageSource =
        typeof image === 'string' ? image : image?.url || image?.path || image?.filename || '';
      const url = resolveProductMediaUrl(imageSource);

      if (!url || seenUrls.has(url)) {
        return null;
      }

      seenUrls.add(url);

      return {
        id:
          image?.id ??
          image?.filename ??
          `${safeProduct.id ?? safeProduct._id ?? 'product'}-${index}`,
        filename: image?.filename || '',
        path: image?.path || '',
        url,
      };
    })
    .filter(Boolean);
}

export function getPrimaryProductImage(product = {}, fallbackImage = '') {
  return getProductGalleryImages(product)[0]?.url || fallbackImage;
}
